import * as iqosActions from 'actions/iqos';
import { processDraftLeads } from 'utils/queue';

const initialState = {
  draftLeads: [],
  leadToDequeue: null,
  leadToQueue: null,
  addingLead: false,
  leadAdded: false,
  leadAddedError: null,
  fetchingVenueLeads: false,
  venueLeadsFetched: false,
  venueLeads: null,
  venueLeadsError: null,
  fetchingArchivedLeads: false,
  archivedLeadsFetched: false,
  archivedLeads: [],
  archivedLeadsPageCount: 0,
  fetchingPendingLeads: false,
  pendingLeadsFetched: false,
  pendingLeads: [],
  pendingLeadsPageCount: 0,
  fetchingSuccessfulLeads: false,
  successfulLeadsFetched: false,
  successfulLeads: [],
  successfulLeadsPageCount: 0,
  searchingStaff: false,
  staffSearched: false,
  iqosStaff: [],
  staffSearchError: null,
  leadFilters: {
    assigned_to_me: true,
  },
  fetchGlobal: true,
};

const iqosReducer = (state = initialState, action) => {
  switch (action.type) {
    case iqosActions.REQUEST_ADD_LEAD:
      return { ...state, ...action.payload };
    case iqosActions.DID_ADD_LEAD:
      return { ...state, ...action.payload };
    case iqosActions.REQUEST_VENUE_LEADS:
      return { ...state, ...action.payload };
    case iqosActions.DID_FETCH_VENUE_LEADS:
      return { ...state, ...action.payload };
    case iqosActions.REQUEST_PENDING_LEADS:
      return { ...state, ...action.payload };
    case iqosActions.DID_FETCH_PENDING_LEADS:
      return { ...state, ...action.payload };
    case iqosActions.REQUEST_ARCHIVED_LEADS:
      return { ...state, ...action.payload };
    case iqosActions.REQUEST_SUCCESSFUL_LEADS:
      return { ...state, ...action.payload };
    case iqosActions.DID_FETCH_SUCCESSFUL_LEADS:
      return { ...state, ...action.payload };
    case iqosActions.DID_FETCH_ARCHIVED_LEADS:
      return { ...state, ...action.payload };
    case iqosActions.REQUEST_UPDATE_LEAD:
      return { ...state, ...action.payload };
    case iqosActions.DID_UPDATE_LEAD:
      return { ...state, ...action.payload };
    case iqosActions.SEARCH_IQOS_STAFF:
      return { ...state, ...action.payload };
    case iqosActions.DID_SEARCH_STAFF:
      return { ...state, ...action.payload };
    case iqosActions.UPDATE_FETCH_GLOBAL:
      return { ...state, ...action.payload };
    case iqosActions.CLEAR_IQOS_FLAGS:
      return { ...state, ...action.payload };
    case iqosActions.UPDATE_LEAD_FILTERS:
      return {
        ...state,
        leadFilters: {
          ...state.leadFilters,
          ...action.payload.leadFilterChanges,
        },
      };
    case iqosActions.REMOVE_DRAFT_LEAD:
      const dl = [...state.draftLeads];
      const ltimestamp = action.payload.leadToDequeue.draft_timestamp;

      for (let index = 0; index < dl.length; index++) {
        const existingLead = dl[index];
        const etimestamp = existingLead.draft_timestamp;

        if (etimestamp === ltimestamp) {
          dl.splice(index, 1);
          break;
        }
      }

      processDraftLeads(dl);
      return { ...state, draftLeads: dl };
    case iqosActions.QUEUE_DRAFT_LEAD:
      const draftLeads = state.draftLeads;
      const newDraftLeads = [...draftLeads, action.payload.leadToQueue];

      processDraftLeads(newDraftLeads);
      return { ...state, draftLeads: newDraftLeads };
    case iqosActions.PROCESS_QUEUED_LEADS:
      processDraftLeads(state.draftLeads);
      return { ...state };
    default:
      return state;
  }
};

export default iqosReducer;



// WEBPACK FOOTER //
// ./src/reducers/iqos/index.js